import { SearchForm } from './SearchForm'
import { withSearchForm } from './withSearchForm'

const Connected = withSearchForm(SearchForm)

export { Connected as SearchForm }
